import { combineReducers } from 'redux'
import { createHighlightedCategoryReducer, createTimeframeReducer, createTrendModeReducer } from 'reducers/globalReducer'
import { CreditAnswer, CreditAppState, CreditLinkageAppState, CreditLinkagePhase, CreditQuestion } from 'interfaces/credit'
import { Reducer } from 'interfaces'
import { RESET_CREDIT, RETRY_CREDIT, SET_CREDIT_ANSWER, SET_CREDIT_ERROR, SET_CREDIT_QUESTIONS } from 'actions/creditActions'
import { SET_MEMBER_INFO } from 'actions/memberActions'

// ===========================================================================//
//                                 CREDIT LINKAGE                             //
// ===========================================================================//

const questionsReducer: Reducer<CreditQuestion[]> = (state = [], action) => {
  switch (action.type) {
    case SET_CREDIT_ERROR:
    case RETRY_CREDIT:
    case RESET_CREDIT:
      return []

    case SET_CREDIT_QUESTIONS:
      return action.payload

    default:
      return state
  }
}

const questionIndexReducer: Reducer<number> = (state = 0, action) => {
  switch (action.type) {
    case SET_CREDIT_QUESTIONS:
    case SET_CREDIT_ERROR:
    case RETRY_CREDIT:
    case RESET_CREDIT:
      return 0

    case SET_CREDIT_ANSWER:
      return state + 1

    default:
      return state
  }
}

const answersReducer: Reducer<CreditAnswer[]> = (state = [], action) => {
  switch (action.type) {
    case SET_CREDIT_QUESTIONS:
    case SET_CREDIT_ERROR:
    case RETRY_CREDIT:
    case RESET_CREDIT:
      return []

    case SET_CREDIT_ANSWER:
      const answer = action.payload
      return [...state, answer]

    default:
      return state
  }
}

const phaseReducer: Reducer<CreditLinkagePhase> = (state = 'form-simple', action) => {
  switch (action.type) {
    case RETRY_CREDIT:
      return 'form-extended'

    case SET_CREDIT_QUESTIONS:
      return action.payload.length === 0
        ? state
        : 'questions'

    case SET_MEMBER_INFO:
      return action.payload.is_creditfile_linked === true
        ? 'form-simple'
        : state

    case RESET_CREDIT:
      return 'form-simple'

    default:
      return state
  }
}

const errorReducer: Reducer<string | null> = (state = null, action) => {
  switch (action.type) {
    case SET_CREDIT_ERROR:
      return action.payload.error

    case RESET_CREDIT:
    case RETRY_CREDIT:
      return null

    default:
      return state
  }
}

const creditAppReducer = combineReducers<CreditAppState>({
  timeframe: createTimeframeReducer('creditscore'),
  trendMode: createTrendModeReducer('creditscore'),
  highlightedCategoryId: createHighlightedCategoryReducer('creditscore'),
  linkage: combineReducers<CreditLinkageAppState>({
    questionIndex: questionIndexReducer,
    answers: answersReducer,
    phase: phaseReducer,
    questions: questionsReducer,
    error: errorReducer,
  }),
})

export default creditAppReducer
